<intelishs-shell-sesion [marca]="marca">
  <router-outlet />
</intelishs-shell-sesion>

<!-- Visor global de archivos, montado UNA vez: el servicio lo abre desde donde sea. Sustituye al
     `intelishs-modal-file-viewer` local, que era un fork de este mismo componente —447 lineas
     identicas— y por eso este repo no recibia ninguna de sus mejoras. -->
<intelishs-file-viewer />

<!-- Volver al inicio: UNA sola vez a nivel de app, nunca por pagina. Aparece cuando ya se bajo lo
     suficiente, en cualquier ruta con scroll.
     Es `position: fixed`, o sea anclado al viewport, asi que le es indiferente el `overflow: auto`
     de `.app-content` del shell —que si rompe cualquier `position: sticky` de las paginas, porque se
     vuelve su contenedor de scroll de referencia sin llegar nunca a scrollear—. -->
<intelishs-back-to-top />
